import { Component, ViewEncapsulation, Input, ChangeDetectorRef, Renderer2, OnChanges, SimpleChanges } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { InventorySupplierXrefBus } from '../../../shared/models/InventorySupplierXrefBus';
import { InventoryReference } from '../../../shared/models/InventoryReference';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'part-suppliers',
    templateUrl: './part-suppliers.component.html',
    styleUrls: ['./part-suppliers.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartSuppliersComponent extends BaseGridEditLineComponent<InventorySupplierXrefBus, null, InventoryService> implements OnChanges {

    @Input() inventoryReferenceData: InventoryReference

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.className = "InventorySupplierXrefBus";
        this.appCode = "InventorySupplierXref";
        this.saveMode = SaveMode.all;
        this.disableCpSearchDialog();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (this.inventoryReferenceData?.hasData  && changes['inventoryReferenceData'] && changes['inventoryReferenceData'].currentValue) {
            this.inventoryReferenceData = changes['inventoryReferenceData'].currentValue;
            this.processGridData();
        }
    }

    override createForm() {
        this.editForm = new UntypedFormGroup({
            'supplierId': new UntypedFormControl(),
            'partNumber': new UntypedFormControl(),
            'contractPrice': new UntypedFormControl(),
            'lastCost': new UntypedFormControl(),
            'currentCost': new UntypedFormControl(),
            'supplierName': new UntypedFormControl(),
         'currentCostDate': new UntypedFormControl(),
        });
    }

    override processGridData() {
        if (this.inventoryReferenceData.hasData !== true) {
            return;
        }
        this.gridData?.forEach((item: InventorySupplierXrefBus) => {
            item.supplierName = this.inventoryReferenceData?.getSupplier(item.supplierId) ?? `Unknown Supplier: ${item.supplierId}`;
        });
        this.gridData = this.gridData?.sort((a, b) => a.supplierName.localeCompare(b.supplierName));
        super.processGridData();
    }

    protected override customPatchForm() {
        this.editForm.controls["supplierName"].setValue(this.inventoryReferenceData.getSupplier(this.editForm.value.supplierId));

    }

    override setForm() {
        var tempDate = new Date();
        if (this.selectedData.currentCostDate) {
            tempDate = new Date(this.selectedData.currentCostDate);
        }
        this.editForm.patchValue({
            supplierId: this.selectedData.supplierId,
            partNumber: this.selectedData.partNumber,
            contractPrice: this.selectedData.contractPrice,
            lastCost: this.selectedData.lastCost,
            currentCost: this.selectedData.currentCost,
            currentCostDate: tempDate,
        });
    }

    supplier(id: any) {
        return this.referenceData.suppliers.find(x => x.value === id);
    }
}
